import { Diff } from '@/utils'
import { EventBus as StoreEvents } from '@/store'
import mitt from 'mitt'

const Track = (event, metadata) => {
  if (!window.Intercom) return
  Intercom('trackEvent', event, metadata)
}

const emitter = mitt()

emitter.on('*', (type, data = {}) => {
  // Project:update
  // Floorplan:shop
  const [resource, event] = type.split(':')

  switch (event) {
    case 'navigation':
      Track('pageview', {
        name: data.name,
        url_link: { url: new URL(data.path, window.location.origin).toString(), value: 'Link' },
        ...data.params,
      })
      break
    case 'filter':
      Track('feature', { filter: resource })
      break
    case 'paginate':
      // do not track ininital load
      if (data.page && data.page >= 2) Track('feature', { paginate: resource, page: data.page, pages: data.pages })
      break
    case 'sort':
      Track('feature', { sort: resource })
      break
    case 'action':
      Track('feature', { action: resource, placement: data.placement })
      break
    case 'shop':
      Track('feature', { shop: resource })
      break
    case 'product':
      Track('feature', { product: resource })
      break
    case 'mypage':
      Track('feature', { mypage: resource })
      break
    case 'comment':
      Track('feature', { comment: resource })
      break
    default: {
      // Track('feature', { [event]: resource})
      break
    }
  }
})

export default emitter

StoreEvents.$on('Project:update', (newVal, oldVal) => {
  let diff = Diff(newVal, oldVal)
})

StoreEvents.$on('Dashboard:fetchOne', data => {})
